<template>
  <admin-wrapper title-translation-path="admin.WATER" :moduleEnabler="moduleEnabler" :hasButtons="false">
    <template #postForm>
      <admin-tabs-layers scope="water" class="pt-8" schema_scope="water" :tab-prop="tab" />
    </template>
  </admin-wrapper>
</template>

<script>
import AdminWrapper from '@/components/AdminWrapper';
import AdminTabsLayers from '@/components/AdminTabsLayers';

export default {
  name: 'WaterSettings',
  components: {
    AdminWrapper,
    AdminTabsLayers,
  },
  props: {
    tab: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    payload: {},
  }),
  computed: {
    moduleEnabler() {
      return {
        name: 'water_data_module_enabled',
        translationPath: 'admin.WATER',
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle', { suffix: this.$i18n.t('admin.WATER') }),
      };
    },
  },
};
</script>
